"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var order_utils_1 = require("@0x/order-utils");
var utils_1 = require("@0x/utils");
exports.calculateLiquidity = function (ordersAndFillableAmounts) {
    var orders = ordersAndFillableAmounts.orders, remainingFillableMakerAssetAmounts = ordersAndFillableAmounts.remainingFillableMakerAssetAmounts;
    var liquidityInBigNumbers = orders.reduce(function (acc, order, curIndex) {
        var availableMakerAssetAmount = remainingFillableMakerAssetAmounts[curIndex];
        if (availableMakerAssetAmount === undefined) {
            throw new Error("No corresponding fillableMakerAssetAmounts at index " + curIndex);
        }
        var tokensAvailableForCurrentOrder = availableMakerAssetAmount;
        var ethValueAvailableForCurrentOrder = order_utils_1.orderCalculationUtils.getTakerFillAmount(order, availableMakerAssetAmount);
        return {
            tokensAvailableInBaseUnits: acc.tokensAvailableInBaseUnits.plus(tokensAvailableForCurrentOrder),
            ethValueAvailableInWei: acc.ethValueAvailableInWei.plus(ethValueAvailableForCurrentOrder),
        };
    }, {
        tokensAvailableInBaseUnits: new utils_1.BigNumber(0),
        ethValueAvailableInWei: new utils_1.BigNumber(0),
    });
    // Turn into regular numbers
    return {
        tokensAvailableInBaseUnits: liquidityInBigNumbers.tokensAvailableInBaseUnits,
        ethValueAvailableInWei: liquidityInBigNumbers.ethValueAvailableInWei,
    };
};
//# sourceMappingURL=calculate_liquidity.js.map